import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import Head from '@/components/common/Head';
import styles from 'styles/jss/original/pages/privacies';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const PrivaciesPage: NextPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.privacy.title}
          description={meta.privacy.description}
          image={meta.privacy.image}
          url={meta.privacy.url}
        />
        <div className={classes.main}>
          <div className={classes.section}>
            <div className={classes.container}>
              <h1 className={classes.titleLevel2}>プライバシーポリシー</h1>
              <div>
                <h3 className={classes.title}>第1条（総則）</h3>
                <ol>
                  <li>
                    <p>
                      small
                      dish(以下「当社」といいます。)は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律(以下「個人情報保護法」といいます。)を遵守すると共に、以下のプライバシーポリシー(以下「本プライバシーポリシー」といいます。)に従い、適切な取扱い及び保護に努めます。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第2条（取得する個人情報）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、Facebbok、Twitter、Google等の外部サービスとの連携による本サービスの利用につき、お客様から以下の情報を取得します。
                    </p>
                    <ul>
                      <li>
                        <p>外部サービスのお客様ID</p>
                      </li>
                      <li>
                        <p>外部サービスに登録しているメールアドレス</p>
                      </li>
                      <li>
                        <p>その他外部サービスで使用しているニックネーム、プロフィール画像</p>
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3 className={classes.title}>第3条（個人情報の利用目的）</h3>
                <ol>
                  <li>
                    <p>当社は、お客様の個人情報を、以下の目的で利用いたします。</p>
                    <ul>
                      <li>
                        <p>本サービスの提供・維持・改善</p>
                      </li>
                      <li>
                        <p>
                          メンテナンス情報や、重要なご連絡など、当社を運用する上で必要な皆様へのお知らせ
                        </p>
                      </li>
                      <li>
                        <p>当社が利用者の皆様に有用だと思われるメールマガジン、お知らせ</p>
                      </li>
                      <li>
                        <p>当社へのご質問、お問い合わせなどに関する回答</p>
                      </li>
                      <li>
                        <p>
                          利用者の皆様の行動、性別、当社内でのアクセス履歴などを用いたターゲティング広告の配信
                        </p>
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3 className={classes.title}>第4条（個人情報利用の制限）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、個人情報保護法その他の法令により許容される場合を除き、お客様の同意を得ず、
                      利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
                    </p>
                    <ul>
                      <li>
                        <p>法令に基づく場合</p>
                      </li>
                      <li>
                        <p>
                          人の生命、身体又は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき
                        </p>
                      </li>
                      <li>
                        <p>
                          公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき
                        </p>
                      </li>
                      <li>
                        <p>
                          国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
                        </p>
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3 className={classes.title}>第5条（個人情報の適正な取得）</h3>
                <ol>
                  <li>
                    <p>当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。</p>
                  </li>
                </ol>
                <h3 className={classes.title}>第6条（個人情報の保護）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、個人情報を取り扱うにあたり管理責任者を置き、個人情報への不正アクセス、個人情報の紛失、改ざん、漏洩等が発生することのない体制の構築に尽力し、個人情報の適切な管理に努めます。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第7条（第三者提供）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、お客様情報のうち、個人情報については、以下の場合を除き、第三者に提供することはありません。
                    </p>
                    <ul>
                      <li>
                        <p>お客様の同意を得た場合</p>
                      </li>
                      <li>
                        <p>法令に基づく場合</p>
                      </li>
                      <li>
                        <p>合併その他の事由による事業の承継に伴って個人情報が提供される場合</p>
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3 className={classes.title}>第8条（個人情報の開示）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、
                      お客様ご本人からのご請求であることを確認の上で、お客様に対し、遅滞なく開示を行います
                      (当該個人情報が存在しないときにはその旨を通知いたします。)。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第9条（本ポリシーの変更）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、
                      必要に応じて、本プライバシーポリシーを変更することがあります。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第10条（お問い合わせ）</h3>
                <ol>
                  <li>
                    <p>
                      当社のお客様情報の取扱いに関するご意見、ご質問、苦情のお申出その他お客様情報の取扱いに関するお問い合わせは、下記窓口までご連絡ください。
                      <br />
                      <br />
                      個人情報取扱お問い合わせ窓口
                    </p>
                    <ul>
                      <li>
                        <p>E-mail：mailer.smalldish@gmail.jp</p>
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
});

export default PrivaciesPage;
